
import { useSearchParams } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';
import { useLanguage } from '../contexts/language';
import { regions_mexico } from '../data/regions';
import { Region } from '../data/types/region-types';

export function useUrlParams(handleRegionSelect: (region: Region) => void, mapRef: React.RefObject<any>) {
  const { toast } = useToast();
  const [searchParams] = useSearchParams();
  const { t, language } = useLanguage();

  const handleInitialParams = () => {
    const success = searchParams.get('success');
    const canceled = searchParams.get('canceled');
    const regionId = searchParams.get('region');
    
    if (success === 'true' && regionId) {
      const region = regions_mexico.find(r => r.region_id === regionId);
      
      toast({
        title: t('donationSuccessful'),
        description: region 
          ? t('donationSuccessMessage', { region: language === 'en' ? region.english_name : region.spanish_name }) 
          : t('donationSuccessGeneric'),
        variant: 'default',
      });
    } else if (canceled === 'true') {
      toast({
        title: t('donationCanceled'),
        description: t('donationCanceledMessage'),
        variant: 'destructive',
      });
    }
    
    const chiapas = searchParams.get('chiapas');
    if (chiapas === 'true') {
      const chiapasRegion = regions_mexico.find(r => r.region_id === 'CHIS');
      if (chiapasRegion) {
        handleRegionSelect(chiapasRegion);
        
        setTimeout(() => {
          if (mapRef.current) {
            mapRef.current.flyToRegion(chiapasRegion);
          }
        }, 500);
      }
    }
    
    const hidalgo = searchParams.get('hidalgo');
    if (hidalgo === 'true') {
      const hidalgoRegion = regions_mexico.find(r => r.region_id === 'HGO');
      if (hidalgoRegion) {
        handleRegionSelect(hidalgoRegion);
        
        setTimeout(() => {
          if (mapRef.current) {
            mapRef.current.flyToRegion(hidalgoRegion);
          }
        }, 500);
      }
    }
  };

  return { handleInitialParams };
}
